import React, {useMemo, useState} from "react";
import {Table, Button, Flex, Tooltip, Modal, Space, Empty} from "antd";
import {
    EditOutlined,
    SearchOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";

import '../CompanyAdministrationTable/CompanyAdministrationTable.css'
import '../../../../api/axiosInstance'
import {axiosInstance} from "../../../../api/axiosInstance";
import {toast} from "react-toastify";

const CompanyAdministrationTable = ({
                                        tableData,
                                        pageNumber,
                                        pageSize,
                                        totalRows,
                                        onFilterChanged,
                                        setMode,
                                        setCompanyAdministrationModalOpened,
                                        setRowData,
                                        refreshData,
                                        fetchCompanyLogo,
                                    }) => {
    const [arrow, setArrow] = useState("Show");

    const [modal, contextHolder] = Modal.useModal();

    const confirm = (id) => {
        modal.confirm({
            title: "Potvrda",
            icon: <ExclamationCircleOutlined/>,
            content: "Jeste li sigurni da želite obrisati firmu?",
            okText: "Da",
            cancelText: "Ne",
            centered: true,
            onOk: () => {
                axiosInstance.delete(`/api/v1/companies/${id}`)
                    .then(res => {
                        toast.success("Tvrtka je uspješno obrisana!");
                        refreshData();
                    }).catch(ex => {
                    toast.error(`${ex.response.data.errorMessage}`);
                })
            },
        });
    };

    const mergedArrow = useMemo(() => {
        if (arrow === "Hide") {
            return false;
        }

        if (arrow === "Show") {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const tableColumns = () => {
        return [
            {
                title: "Naziv",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "OIB",
                dataIndex: "oib",
                key: "oib",
            },
            {
                title: "Adresa",
                dataIndex: "addressStr",
                key: "address",
            },
            {
                title: "Vlasnik",
                dataIndex: "ownerStr",
                key: "ownerStr",
            },
            {
                title: "",
                key: "operation",
                //fixed: "right",
                width: "150px",
                render: (text, record, index) => (
                    <Flex vertical={false} gap={"4px"}>
                        <Tooltip
                            placement="top"
                            title={<span>Pregled</span>}
                            arrow={mergedArrow}
                        >
                            <Button
                                type="text"
                                size="large"
                                icon={<SearchOutlined/>}
                                onClick={() => {
                                    setMode("preview");
                                    fetchCompanyLogo(record.id);
                                    setRowData(record);
                                    setCompanyAdministrationModalOpened(true);
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            placement="top"
                            title={<span>Uređivanje</span>}
                            arrow={mergedArrow}
                        >
                            <Button
                                type="text"
                                size="large"
                                icon={<EditOutlined/>}
                                onClick={() => {
                                    setMode("edit");
                                    fetchCompanyLogo(record.id);
                                    setCompanyAdministrationModalOpened(true);
                                    setRowData(record);
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            placement="top"
                            title={<span>Brisanje</span>}
                            arrow={mergedArrow}
                        >
                            <Space>
                                <Button
                                    type="text"
                                    size="large"
                                    danger
                                    icon={<DeleteOutlined/>}
                                    onClick={() => confirm(record.id)}
                                />
                            </Space>
                        </Tooltip>
                    </Flex>
                ),
            },
        ];
    };

    return (
        <>
            <Table
                columns={tableColumns()}
                dataSource={tableData}
                onChange={(pagination, filters, sorter) =>
                    onFilterChanged(pagination, filters, sorter)
                }
                style={{marginTop: "32px"}}
                pageNumber={pageNumber}
                pageSize={pageSize}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30'],
                    total: totalRows,
                    showTotal: (total, range) => `Ukupan broj rezultata: ${totalRows}`
                }}
                bordered
                scroll={{x: 700}}
                locale={{emptyText: <Empty description="Nije pronađena niti jedna tvrtka."/>}}
            />
            {contextHolder}
        </>
    );
};
export default CompanyAdministrationTable;
